import { render } from "./AdminFooter.vue?vue&type=template&id=7a4721b5"
const script = {}

import "./AdminFooter.vue?vue&type=style&index=0&id=7a4721b5&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__